export default __webpack_public_path__ + "static/media/box.8c0667df.svg";